import { VIRTUAL_LIST_FORCE_RENDER } from './constants'

export function forceRender(id) {
    return {
        type: VIRTUAL_LIST_FORCE_RENDER,
        data: {
            id,
        },
    }
}
